define([
	"dojo/_base/array",
	"dojo/dom-class",
	"csi/_base/underscore",
	"csi/action",
	"csi/locale",
	"csi/page",
	"csi/reflection",
	"csi/resolver",
	"csi/router",
	"csi/state/rootStore",
	"csi/types",
	"csi/xml"
], function(array, domClass, _, csiAction, locale, page, reflection, resolver, {setLocationRevisionUrl}, {sessionStore}, types, xml) {

	csiAction.registerControllers("", {
		ApproveTask: "Workflow.UTCController",
		CompleteTask: "Workflow.UTCController",
		RejectTask: "Workflow.UTCController"
	});

	/**
	 * If latest revision is in Draft state, then navigate to the new revision
	 * @param {Controller} ac 
	 * @return {Promise<void> | undefined}
	 */
	function postActionApproveTask(ac) {
		const {m_cache} = ac;
		const actionItemStepResponse = ac.getNode();
		const actionItemStep = m_cache.get(actionItemStepResponse?.__Parent__);
		const actionItem = m_cache.get(actionItemStep?.__Parent__);
		const revision = m_cache.get(actionItem?.__Parent__);
		const master = m_cache.get(revision?.__Parent__);
		const latest = m_cache.get(master?.LatestRevision);

		if (latest?.State === reflection.REVISION_DRAFT) {
			return setLocationRevisionUrl(latest.$URL);
		} else {
			return page.refreshViews();
		}
	}

	return {
		postActionApproveTask,

		onDrawDueDate: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// special code to determine if due date is today or later than today - have to make sure hour of day taken into consideration
			var value = xml.nodeGetAttributeValue(ctx.getNode(), h.m_id);
			if (value > 0) {
				domClass.remove(refNode, 'status-', true);

				if (types.isTimeToday(value))
					domClass.add(refNode, 'csi-bg-yellow');
				else if (value < types.getDateTime())
					domClass.add(refNode, 'csi-bg-red');
			}
		},

		preActionResponder: function(ac) {
			var state = xml.nodeGetAttributeValue(ac.getNode(), 'State');

			if ((state != 'ActionItemStep.State:DRAFT') && (state != 'ActionItemStep.State:OPEN')) {
				alert(locale.resource('ERROR_ADD_RESPONDER'));
				return false;
			}

			return true;
		},

		onAccessActionApproveTask: function(/*Context*/ctx, /*Action*/action) {
			var type = this._getWorkflowStepType(ctx);
			return type == "APPROVAL" || type == "REVIEW";
		},

		onAccessActionCompleteTask: function(/*Context*/ctx, /*Action*/action) {
			var type = this._getWorkflowStepType(ctx);
			return type == "ACTIVITY";
		},

		isRejectable: function(/*Context*/ctx) {
			return _.some(this._getWorkflowStep(ctx).OutTransitions, function(t) {
				return !ctx.cache.getNode(t).OnAuthorized;
			});
		},

		onAccessActionRejectTask: function(/*Context*/ctx, /*Action*/action) {
			var type = this._getWorkflowStepType(ctx);
			return type == "APPROVAL" || type == "REVIEW" ||
				(type == "ACTIVITY" && this.isRejectable(ctx));
		},

		onAccessActionChangeTaskUser: function(/*Context*/ctx, /*Action*/action) {
			var task = ctx.getNode();
			if (!xml.nodeHasRight(task, xml.RIGHT_ADMIN))
				return false;

			var step = ctx.cache.getNode(task.__Parent__, true);
			return task.Recommendation == 'ActionItemStepResponse.Recommendation:NONE'
				&& step.State == 'ActionItemStep.State:OPEN';
		},

		_getWorkflowStep: function(ctx) {
			var aiStep = ctx.cache.getChildNode(ctx.getNode(), "__Parent__", true);
			var wfStep = ctx.cache.getChildNode(aiStep, "WorkflowStep", true);
			return wfStep;
		},

		_getWorkflowStepType: function(ctx) {
			return xml.enumGetText(this._getWorkflowStep(ctx)?.StepType);
		},

		_getWorkflowStepType2: function(/*Node*/ aiStepResponse, /*Context*/ ctx) {
			var aiStep = ctx.cache.getChildNode(aiStepResponse, "__Parent__", true);
			var wfStep = resolver.resolveNode(aiStep.WorkflowStep, false, ctx.cache);
			return xml.enumGetText(wfStep.StepType);
		},

		onNewWorkflowNotificationTemplate: function(ac) {
			ac.m_cnNew.changeAttribute("Type", xml.ATTR_STRING, "Workflow");
		},

		onAccessActionWFApproveTask: function(/*Context*/ctx, /*Action*/action) {
			var aiStepResponse = this.userHasLatestActionStepResponse(ctx);
			var type = aiStepResponse ? this._getWorkflowStepType2(aiStepResponse, ctx) : "";
			return type == "APPROVAL" || type == "REVIEW";
		},

		onAccessActionWFCompleteTask: function(/*Context*/ctx, /*Action*/action) {
			var aiStepResponse = this.userHasLatestActionStepResponse(ctx);
			var type = aiStepResponse ? this._getWorkflowStepType2(aiStepResponse, ctx) : "";
			return type == "ACTIVITY";
		},

		onAccessActionWFRejectTask: function(/*Context*/ctx, /*Action*/action) {
			var aiStepResponse = this.userHasLatestActionStepResponse(ctx);
			var type = aiStepResponse ? this._getWorkflowStepType2(aiStepResponse, ctx) : "";
			return type == "APPROVAL" || type == "REVIEW";
		},

		userHasLatestActionStepResponse: function(/*Context*/ctx) {
			const {cache} = ctx;
			const latestRevisionNode = cache.getChildNode(ctx.getNode(), "__Parent__", true);
			const node = resolver.resolveNode(latestRevisionNode.WorkflowExecution, false, cache);
			let aiStepResponse = null;

			if (node) {
				let i = 0;
				const responses = [];

				for (i in node.OpenResponses) {
					responses.push(node.OpenResponses[i]);
				}

				array.forEach(responses, function(response) {
					const actionItemStepResponse = resolver.resolveNode(response, false, cache);
					if (actionItemStepResponse && actionItemStepResponse.User == sessionStore.currentUser.$URL) {
						aiStepResponse = actionItemStepResponse;
					}
				});
			}

			return aiStepResponse;
		}
	};
});